module.exports = __webpack_public_path__ + "img/EventWinPage0926.4c873012.jpg";